// src/index.js
// Suppress all console.log output in production as early as possible
if (import.meta.env.MODE === "production") {
  console.log = function () {};
}
import React from "react";
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { PostHogProvider, PostHogErrorBoundary } from "posthog-js/react";
import posthog from "posthog-js";

const isProd = import.meta.env.MODE === "production";
const enablePosthog = import.meta.env.VITE_POSTHOG_ENABLED !== "false";
const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;

if (posthogKey && enablePosthog) {
  posthog.init(posthogKey, {
    api_host: "https://static.equineoffice.io",
    defaults: "2026-10-30",
    capture_exceptions: true,
    enable_recording_console_log: import.meta.env.MODE !== "development",
    //debug: import.meta.env.MODE === "development",
    debug: false,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true,
      },
      maskInputFn: (text, element) => {
        // Redact anything that looks like a credit card number
        if (/\d{4}[\s\-]?\d{4}[\s\-]?\d{4}[\s\-]?\d{4}/.test(text)) {
          return "**** **** **** ****";
        }
        return text;
      },
    },
  });
}

window.posthog = posthog;

const app = (
  <Router>
    {posthogKey && enablePosthog ? (
      <PostHogProvider client={posthog}>
        <PostHogErrorBoundary>
          <App />
        </PostHogErrorBoundary>
      </PostHogProvider>
    ) : (
      <App />
    )}
  </Router>
);

// Remove the overlay and flag after React mounts

function cleanupUpdatingOverlay() {
  // Always hide the updating overlay and remove the flag after React mounts
  const overlay = document.getElementById("updating-overlay");
  if (overlay) overlay.style.display = "none";
  localStorage.removeItem("showUpdating");
  // Hide the #root2 overlay after React mounts
  const root2 = document.getElementById("root2");
  if (root2) root2.style.display = "none";
}

render(app, document.getElementById("root"));
cleanupUpdatingOverlay();
